import { render, staticRenderFns } from "./QPR-Form.vue?vue&type=template&id=93496dd0"
import script from "./QPR-Form.vue?vue&type=script&lang=js"
export * from "./QPR-Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports